import clsx from "clsx";

import { SortableItem } from "@smart/itops-sb-design-system-dom";

import { FieldCard } from "./field-card";
import { LanguageKey } from "../../../types";
import { DroppableSeparator } from "../drag-and-drop";
import {
  ConditionActions,
  FieldTemplate,
  GqlFieldValues,
  GqlGroupValues,
  GqlMatterLayout,
  GqlMatterType,
  LoadMatterFields,
  OnDeleteField,
  OnFieldTypeChange,
  OnUpdateField,
  QuestionEditMode,
} from "../types";
import { ChangeStatus } from "../utils";

type FieldProps = {
  index: number;
  loading?: boolean;
  shrinking?: boolean;
  isEditing?: boolean;
  isDragging?: boolean;
  mode?: QuestionEditMode;
  item: GqlFieldValues;
  onUpdateField: OnUpdateField;
  onDeleteField: OnDeleteField;
  matterLayouts?: GqlMatterLayout[];
  matterTypes?: GqlMatterType[];
  loadMatterFields: LoadMatterFields;
  conditionActions: ConditionActions;
  groupLayout?: GqlGroupValues["layout"] | null;
  groupMatterField?: GqlGroupValues["field"] | null;
  onFieldTypeChange: OnFieldTypeChange;
  excludingFieldTemplates: FieldTemplate[];
  lastActiveIds: string[];
  viewingLanguage: LanguageKey;
  hasSubmissionLinks?: boolean;
  changeStatus?: ChangeStatus;
  disableDrop?: boolean;
  allowChangeFieldType?: boolean;
};

export const Field = ({
  item: field,
  index,
  loading,
  shrinking,
  isEditing,
  isDragging,
  mode,
  onUpdateField,
  onDeleteField,
  matterLayouts,
  matterTypes,
  loadMatterFields,
  conditionActions,
  groupLayout,
  groupMatterField,
  onFieldTypeChange,
  excludingFieldTemplates,
  lastActiveIds,
  viewingLanguage,
  hasSubmissionLinks,
  changeStatus,
  disableDrop,
  allowChangeFieldType,
}: FieldProps) => (
  <SortableItem id={field.uri}>
    {({ dragHandleProps, isDragging: isDraggingFromSortable }) => (
      <>
        <FieldCard
          className={clsx(isDraggingFromSortable && "opacity-50")}
          field={field}
          loading={loading}
          onUpdateField={onUpdateField}
          onDeleteField={onDeleteField}
          dragHandleProps={dragHandleProps}
          isShrinking={shrinking}
          isDragging={isDragging || isDraggingFromSortable}
          editing={isEditing}
          matterLayouts={matterLayouts}
          matterTypes={matterTypes}
          loadMatterFields={loadMatterFields}
          conditionActions={conditionActions}
          groupLayout={groupLayout}
          groupMatterField={groupMatterField}
          onFieldTypeChange={onFieldTypeChange}
          excludingFieldTemplates={excludingFieldTemplates}
          lastActiveIds={lastActiveIds}
          viewingLanguage={viewingLanguage}
          hasSubmissionLinks={hasSubmissionLinks}
          changeStatus={changeStatus}
          allowChangeFieldType={allowChangeFieldType}
        />
        <DroppableSeparator
          index={index + 1}
          groupUri={field.groupUri}
          disabled={mode === "reordering" || disableDrop}
        />
      </>
    )}
  </SortableItem>
);
